<template>
  <div class="ds-control ds-form-item ds-audit-state" :class="getCss">
    <template v-if="simple && readOnly && !isDesign">
      <DsfTextProxy
        v-show="isVisible"
        v-model="value"
        v-bind="_self.$props"
      ></DsfTextProxy>
      <span v-show="isVisible" v-if="value != ''">{{ append }}</span>
      <slot name="error">
        <div v-if="errors.length > 0" class="ds-error-text">
          {{ errorsMsg }}
        </div>
      </slot>
    </template>
    <template v-else>
      <DsfFieldLabel
        v-show="isVisible"
        v-if="showLabel"
        :mode="showDataCaptionMode"
        :style="getLabelWidthStyle()"
        :show-icon="showDataCaptionIcon"
        :trigger="showDataCaptionTrigger"
        :data-caption="dataCapion"
        :is-design="isDesign"
        :owner="_self"
      >
        {{ $t(label) }}
      </DsfFieldLabel>
      <div
        v-show="isVisible"
        class="ds-form-block"
        :style="getFormItemBlockMarginLeft()"
      >
        <!--只读状态只显示div-->
        <div v-if="readOnly" class="ds-form-readonly">
          <DsfTextProxy
            v-model="value"
            v-bind="_self.$props"
            :show-label="false"
          ></DsfTextProxy>
          <span v-if="value != ''">{{ append }}</span>
        </div>
        <slot name="error">
          <div v-if="errors.length > 0" class="ds-error-text">
            {{ errorsMsg }}
          </div>
        </slot>
      </div>
      <div
        v-show="showOpenBtn"
        v-drag
        class="ds-audit-state-fixed-btn"
        @click="showDrawerOpen"
      >
        审
      </div>
      <el-drawer
        append-to-body
        title="审核信息"
        :visible.sync="drawerOpen"
        direction="rtl"
        :destroy-on-close="true"
        size="40%"
        custom-class="ds-audit-state-drawer"
        @close="drawerClose"
      >
        <div v-show="showOpenBtn" class="ds-audit-state-drawer-list">
          <template v-if="mandatoryErrorList.length">
            <div class="ds-audit-state-drawer-title" type="mandatory">
              <span>强制型</span>
            </div>
            <div
              v-for="(item, index) in mandatoryErrorList"
              :key="'mandatory' + index"
              class="ds-audit-state-drawer-item"
              @click="errorClick(item)"
            >
              <div class="ds-audit-state-drawer-top">
                <span class="ds-audit-state-drawer-item-label">
                  {{ getSubTableLabel(item) }}{{ item.label }}
                </span>
                ：{{ item.message }}
              </div>
            </div>
          </template>
          <template v-if="verifyErrorList.length">
            <div class="ds-audit-state-drawer-title" type="verify">
              <span>核实型</span>
            </div>
            <div
              v-for="(item, index) in verifyErrorList"
              :key="'verify' + index"
              class="ds-audit-state-drawer-item"
              @click="errorClick(item)"
            >
              <div class="ds-audit-state-drawer-top">
                <span class="ds-audit-state-drawer-item-label">
                  {{ getSubTableLabel(item) }}{{ item.label }}
                </span>
                ：{{ item.message }}
              </div>
              <div class="ds-audit-state-drawer-remark">
                <span class="ds-audit-state-drawer-remark-label">说明：</span>
                <el-input
                  :value="item.remark"
                  class="ds-audit-state-drawer-remark-input"
                  size="mini"
                  placeholder="请输入备注"
                  @input="remarkInput($event, item)"
                ></el-input>
              </div>
            </div>
          </template>
          <template v-if="ignoreErrorList.length">
            <div class="ds-audit-state-drawer-title" type="ignore">
              <span>忽略型</span>
            </div>
            <div
              v-for="(item, index) in ignoreErrorList"
              :key="'ignore' + index"
              class="ds-audit-state-drawer-item"
              @click="errorClick(item)"
            >
              <div class="ds-audit-state-drawer-top">
                <span class="ds-audit-state-drawer-item-label">
                  {{ getSubTableLabel(item) }}{{ item.label }}
                </span>
                ：{{ item.message }}
              </div>
            </div>
          </template>
        </div>
        <div v-show="!showOpenBtn" style="text-align: center">无错误信息</div>
        <div v-show="showSaveBtn" class="ds-audit-state-drawer-btns">
          <dsf-button @click="save">确认保存</dsf-button>
        </div>
      </el-drawer>
    </template>
  </div>
</template>

<script>
export default dsf.component({
  name: "DsfAuditState",
  ctrlCaption: "审核状态",
  mixins: [$mixins.vDrag, $mixins.formulaAuditState],
  props: {
    forceHidden: {
      type: Boolean,
      default: true,
    },
    desCopyedChangeCaption:{
      type:Boolean,
      default:false
    },
  },
});
</script>
